import React from 'react';

interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
}

export const Textarea: React.FC<TextareaProps> = ({ label, id, error, className, ...props }) => {
  return (
    <div className="w-full">
      {label && <label htmlFor={id} className="block text-sm font-medium text-neutral-700 mb-1">{label}</label>}
      <textarea
        id={id}
        className={`block w-full px-3 py-2 border ${error ? 'border-red-500' : 'border-neutral-300'} rounded-md shadow-sm focus:outline-none ${error ? 'focus:ring-red-500 focus:border-red-500' : 'focus:ring-homeme focus:border-homeme'} sm:text-sm ${className}`}
        rows={4}
        {...props}
      />
      {error && <p className="mt-1 text-xs text-red-600">{error}</p>}
    </div>
  );
};
